import { api } from "libs";
import {
  StreamingIntegration,
  StreamingAPIKey,
  CreateStreamingIntegrationRequest,
  CreateStreamingIntegrationResponse,
} from "store/types";
import {
  STREAMING_INTEGRATIONS,
  STREAMING_INTEGRATION_BY_ID,
  STREAMING_INTEGRATION_KEYS,
  STREAMING_INTEGRATION_KEY_ROTATE,
} from "libs/api/endpoints";

export const fetchStreamingIntegrations = async (): Promise<StreamingIntegration[]> =>
  api.get(STREAMING_INTEGRATIONS, {
    errorMessage: {
      title: "Failed to fetch Streaming Integrations",
    },
  });

export const createStreamingIntegration = async (
  data: CreateStreamingIntegrationRequest,
): Promise<CreateStreamingIntegrationResponse> =>
  api.post(STREAMING_INTEGRATIONS, data, {
    errorMessage: {
      title: "Failed to create Streaming Integration",
    },
  });

export const fetchStreamingAPIKeys = async (integrationId: string): Promise<StreamingAPIKey[]> =>
  api.get(STREAMING_INTEGRATION_KEYS(integrationId), {
    errorMessage: {
      title: "Failed to fetch Streaming API Keys",
    },
  });

export const rotateStreamingAPIKey = async (
  integrationId: string,
  keyId: string,
): Promise<{
  key: string;
  details: StreamingAPIKey;
}> =>
  api.post(
    STREAMING_INTEGRATION_KEY_ROTATE(integrationId, keyId),
    {},
    {
      errorMessage: {
        title: "Failed to rotate Streaming API Key",
      },
    },
  );

export const deleteStreamingIntegration = async (integrationId: string): Promise<void> =>
  api.delete(STREAMING_INTEGRATION_BY_ID(integrationId), {
    errorMessage: {
      title: "Failed to delete Streaming Integration",
    },
  });
